import * as yup from "yup";
import { NorwegianId } from "norwegian-national-id-validator";
import { BookingErrorsDto } from "../../../Api/Model/BookingSteps/BookingErrorsDto.csharp";

const genericError = "Error";

export const stepOneValidator = (errors?: BookingErrorsDto) =>
  yup.object().shape({
    smsCode: yup
      .string()
      .required(errors?.fieldIsRequired)
      .typeError(errors?.smsCode || genericError),
    personalIdNumber: yup
      .string()
      .required(errors?.fieldIsRequired || genericError)
      .test(
        "type",
        errors?.personalNumber || genericError,
        (value) => value != undefined && !isNaN(Number(value))
      )
      .test(
        "length",
        errors?.personalNumber || genericError,
        (value) => value != undefined && value.toString().length == 11
      )
      .test(
        "valid",
        errors?.personalNumber || genericError,
        (value) => value != undefined && NorwegianId(value).isValid()
      ),
  });

export const stepTwoValidator = (errors?: BookingErrorsDto) =>
  yup.object().shape({
    confirmationCode: yup
      .string()
      .required(errors?.fieldIsRequired || genericError)
      .test(
        "length",
        errors?.smsCodeLength || genericError,
        (value) => !!value && value.length == 6
      ),
  });
